import { Link } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";

export const Footer = () => (
  <footer
    className="mt-24 bg-[#1E4637] text-[#F5EFEB]"
    data-testid="site-footer"
  >
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid md:grid-cols-4 gap-10">
      <div className="md:col-span-2">
        <div className="serif text-3xl text-[#E7C766] leading-tight">
          <span className="italic">Martin's</span> Marvellous Melbourne
        </div>
        <div className="text-xs tracking-[0.28em] uppercase text-[#E7C766]/80 mt-1">
          Walking Tours · Est. 1835 — 2026
        </div>
        <p className="mt-4 text-sm max-w-md leading-relaxed opacity-90">
          A walking tour through Melbourne's CBD — gold rush stories, hidden arcades,
          Victorian architecture, and the small human moments that made a city marvellous.
        </p>
      </div>

      <div>
        <div className="text-xs uppercase tracking-[0.24em] text-[#E7C766] mb-4">
          Explore
        </div>
        <ul className="space-y-2 text-sm">
          <li><Link to="/individual" className="hover:text-[#E7C766]" data-testid="footer-individual">Individual Tours</Link></li>
          <li><Link to="/corporate" className="hover:text-[#E7C766]" data-testid="footer-corporate">Corporate Tours</Link></li>
          <li><Link to="/school" className="hover:text-[#E7C766]" data-testid="footer-school">School Tours</Link></li>
          <li><Link to="/education" className="hover:text-[#E7C766]" data-testid="footer-education">Education · BASIC UNITY</Link></li>
          <li><Link to="/gift-vouchers" className="hover:text-[#E7C766]" data-testid="footer-vouchers">Gift Vouchers</Link></li>
          <li><Link to="/quiz" className="hover:text-[#E7C766]" data-testid="footer-quiz">Melbourne Quiz</Link></li>
          <li><Link to="/leave-a-review" className="hover:text-[#E7C766]" data-testid="footer-leave-review">Leave a Review</Link></li>
          <li><Link to="/blog" className="hover:text-[#E7C766]" data-testid="footer-blog">Journal</Link></li>
          <li><Link to="/gallery" className="hover:text-[#E7C766]" data-testid="footer-gallery">Gallery</Link></li>
          <li><Link to="/faq" className="hover:text-[#E7C766]" data-testid="footer-faq">FAQ</Link></li>
        </ul>
      </div>

      <div>
        <div className="text-xs uppercase tracking-[0.24em] text-[#E7C766] mb-4">
          Get in touch
        </div>
        <a
          href="mailto:Mmmwt35@gmail.com"
          className="flex items-center gap-2 text-sm hover:text-[#E7C766]"
          data-testid="footer-mailto"
        >
          <Mail size={16} /> Mmmwt35@gmail.com
        </a>
        <a
          href="tel:+61422007703"
          className="flex items-center gap-2 text-sm mt-3 hover:text-[#E7C766]"
          data-testid="footer-phone"
        >
          <Phone size={16} /> 0422 007 703
        </a>
        <div className="flex items-start gap-2 text-sm mt-3 opacity-90" data-testid="footer-meeting-point">
          <MapPin size={16} className="mt-0.5 shrink-0" />
          <span>Meet at Federation Square — outside the big screen</span>
        </div>
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 text-xs opacity-70 flex justify-between">
        <span>© {new Date().getFullYear()} Martin's Marvellous Melbourne Walking Tours</span>
        <Link to="/admin" className="hover:text-[#E7C766]" data-testid="footer-admin-link">Admin</Link>
      </div>
    </div>
  </footer>
);

export default Footer;
